module.exports = __webpack_public_path__ + "img/Pfingstbaum-Platz.9b128a1f.jpg";